<style scoped lang="stylus" rel="stylesheet/stylus">
.container
  display flex
  flex-direction column
  background #f2f2f2
  height 100%
  .content
    height 0
    flex 1
    overflow-y scroll
    .title
      font-size 15px
      color #333
      text-align center
      font-weight bold
    .tip
      font-size 14px
      color #888
</style>

<template>
	<div class="container">
		<nav-bar />
		<div class="content" ref="content">
			<pull-refresh v-model="isLoading" :pullDisabled="false" @pullRefresh="onRefresh">
				<list
					v-model="moreLoading"
					:moreFinished="moreFinished"
					moreFinishedText="没有更多了"
					@moreLoad="moreLoad"
				>
					<p>store次数: {{ count }}</p>
					<p>刷新次数: {{ reflashCount }}</p>
					<div>
						<div class="title">过滤器</div>
						时间：{{ date | formatDate }}
					</div>
					<div>
						<div class="title">计算属性set,get</div>
						姓：{{ firstName }} 名：{{ lastName }} 姓名：{{ fullName }}
						<!--<van-field type="text" v-model="fullName"></van-field>-->
						<input type="text" v-model="fullName" />
					</div>
					<div>
						<div class="title">class绑定</div>
						<div :class="{ active: isActive, error: isError }">对象语法</div>
						<div :class="[activeCls, errorCls, isVisited ? visitedCls : '']">数组语法</div>
						<div :class="[{ active: isActive, error: isError }, visitedCls]">数组语法中使用对象语法</div>
						<div :class="computedClasses">数组语法中使用对象语法-计算属性</div>
					</div>
					<div>
						<div class="title">style绑定</div>
						<div :style="{ color: color, 'font-weight': fontWeight, fontSize: fontSize }">对象语法</div>
						<div :style="[styleA, styleB]">数组语法</div>
					</div>
					<div>
						<div class="title">条件渲染指令</div>
						<div class="tip">
							Vue 在渲染元素时
							，出于效率考虑，会尽可能地复用已有的元素而非重新渲染,加唯一值的key属性可以避免。v-show不能在template上使用
						</div>
						<template v-if="type === 'name'">
							<label>用户名</label>
							<input type="text" placeholder="请输入用户名" key="name-input" />
						</template>
						<template v-else>
							<label>邮箱</label>
							<input type="text" placeholder="请输入邮箱" key="mail-input" />
						</template>
						<button @click="toggleType">切换输入类型</button>
					</div>
					<div v-for="i in listLength" @click="lineClick" :key="i">第{{ i }}行</div>
				</list>
			</pull-refresh>
			<tab-bar />
		</div>
	</div>
</template>

<script>
import tabBar from '../../components/navigation/tab-bar'
import navBar from '../../components/navigation/nav-bar'
import pullRefresh from '../../components/feedback/pull-refresh'
import list from '../../components/display/list'
import { mapState } from 'vuex'
export default {
	name: 'vuejswar',
	components: {
		tabBar,
		navBar,
		pullRefresh,
		list
	},
	props: {},
	watch: {},
	data() {
		return {
			listLength: 50,
			reflashCount: 0,
			isLoading: false,
			moreLoading: false,
			moreFinished: false,
			contentScrollTop: 0,
			date: new Date(),

			firstName: 'Jack',
			lastName: 'Green',

			isActive: true,
			isError: false,
			activeCls: 'active',
			errorCls: 'error',
			isVisited: true,
			visitedCls: 'visited',
			btnSize: 'large',
			disabled: true,

			color: 'blue',
			fontWeight: 'bold',
			fontSize: '20px',
			styleA: {
				color: 'red',
				'font-size': '18px'
			},
			styleB: {
				'font-weight': 'bold'
			},

			type: 'name'
		}
	},
	filters: {
		formatDate(value) {
			let date = new Date(value)
			let year = date.getFullYear()
			let month = date.getMonth() + 1
			let day = date.getDay()
			return `${year}-${month}-${day}`
		}
	},
	computed: {
		...mapState({
			count: state => state.count
		}),
		//    fullName() {
		//        return `${this.firstName} ${this.lastName}`
		//    },
		fullName: {
			get() {
				return `${this.firstName} ${this.lastName}`
			},
			set(newValue) {
				this.firstName = newValue.split(' ')[0]
				this.lastName = newValue.split(' ')[1]
			}
		},
		computedClasses() {
			return [
				'btn',
				{
					['btn-' + this.btnSize]: this.size !== '',
					'btn-disabled': this.disabled
				}
			]
		}
	},
	methods: {
		toggleType() {
			this.type = this.type === 'name' ? 'mail' : 'name'
		},
		onRefresh() {
			console.log('onRefresh')
			setTimeout(() => {
				this.listLength = 50
				this.$toast('刷新成功')
				this.isLoading = false
				this.moreLoading = false
				this.moreFinished = false
				this.reflashCount++
			}, 3000)
		},
		moreLoad() {
			console.log('moreLoad')
			setTimeout(() => {
				this.listLength += 50
				this.moreLoading = false
				if (this.listLength >= 300) {
					this.moreFinished = true
				}
			}, 1000)
		},
		lineClick() {
			console.log('scrollTop', this.$refs.content.scrollTop)
		}
	},
	beforeRouteLeave(to, from, next) {
		this.contentScrollTop = this.$refs.content.scrollTop
		console.log(this.contentScrollTop)
		next()
	},
	activated() {
		this.$nextTick(() => {
			this.$refs.content.scrollTop = this.contentScrollTop
		})
	}
}
</script>
